// extracted by mini-css-extract-plugin
module.exports = {"section":"Tabs-section-84t1b","button":"Tabs-button-f5kjL","buttonActive":"Tabs-buttonActive-Ag08C"};